import React from 'react';
import styled from 'styled-components';

const Text = styled.div`
  padding-right: 24px;
`;

export default Text;
